import "./created-date";
import "./last-modified";
import "./manual";
import "./priority";
import "./ticket-number";

import { SORT_REGISTRY } from "./base";

export default SORT_REGISTRY;
